import { FieldSet } from '@alfa-retail-react/components';
import Button from '@alfa-retail-react/components/button';
import Link from '@alfa-retail-react/components/link';
import Modal from '@alfa-retail-react/components/modal';
import React, { FC, useEffect } from 'react';

import { ReturnAnalyticsType } from 'app/analytics/useAnalytics';
import { useIsDesktop } from 'app/utils/useWindowType';

import './HowItWorks.less';

interface HowItWorksProps {
    title: string;
    analytics: ReturnAnalyticsType;
}

const clientRequirements = [
    {
        value: (
            <span>
                <span className="accent">
                    как карта, с которой можно разделить покупку на части
                </span>{' '}
                - если вы совершаете покупку от 50 BYN и и делите её на части от
                1 до 12 месяцев в приложении INSNC. Для этого в истории операций
                выберите ту, в которой есть пометка Разделить на части с Красной
                картой.
            </span>
        ),
        className: 'advantagesListItem',
    },
    {
        value: (
            <span>
                <span className="accent">как кредитная карта</span> - если вы
                снимаете наличные, делаете платежи в ЕРИП, переводы с карты на
                карту и покупки до 50 BYN. А также на все покупки, которые вы не
                разделили на части в приложении INSNC.
            </span>
        ),
        className: 'advantagesListItem',
    },
    {
        value: (
            <span>
                <span className="accent">как дебетовая карта</span> - если вы
                пополните карту своими деньгами сверх лимита. Вы можете хранить
                деньги, делать любые покупки и платежи.
            </span>
        ),
        className: 'advantagesListItem',
    },
];

export const ProductRequirements = () => {
    return (
        <FieldSet className="advantagesList" fieldsProps={clientRequirements} />
    );
};

/**
 * Пользователь кликает по ссылке "Как работает красная карта"
 */
const EVENT_CLICK = 'ProductPageClickHowTo';
/**
 * Появление модального окна после клика по ссылке
 */
const EVENT_VIEW = 'ProductPageModuleWindowView';
/**
 * Клик по кнопке "Понятно" на модальном окне
 */
const EVENT_CONFIRM = 'ProductPageModuleWindowButton';

export const HowItWorks: FC<HowItWorksProps> = ({ title, analytics }) => {
    const [open, setOpen] = React.useState(false);
    const handleModalOpen = () => {
        if (!open) {
            analytics.fullEvent(EVENT_CLICK);
        }
        setOpen(!open);
    };

    const handleConfirm = () => {
        analytics.fullEvent(EVENT_CONFIRM);
        setOpen(false);
    };

    const [isDesktop] = useIsDesktop();

    useEffect(() => {
        if (open) {
            analytics.fullEvent(EVENT_VIEW);
        }
    }, [open]);

    return (
        <div className="HowItWorks">
            <Link onClick={handleModalOpen} view="default">
                {title}
            </Link>
            <Modal
                isDesktop={isDesktop}
                className="IntroProductAdvantages"
                title={title}
                open={open}
                onClose={handleModalOpen}
                content={<ProductRequirements />}
                actionButton={
                    <Button
                        className="confirm"
                        view="accent"
                        size="s"
                        onClick={handleConfirm}
                        block
                    >
                        Понятно
                    </Button>
                }
            />
        </div>
    );
};
